import type { NAuth } from '@app/types';

export const adaptUserToRedux = (
  data: NAuth.ModelAuthentication
): NAuth.User => {
  const {
    UserId,
    Database,
    NameFirst,
    NameLast,
    Email,
    Phone,
    Gender,
    Photo,
    DateBirth,
    IsAdmin,
    AccessCode,
    Position,
    ActiveBranchId,
  } = data;

  const result: NAuth.User = {
    userId: UserId,
    database: Database,
    nameFirst: NameFirst,
    nameLast: NameLast,
    email: Email,
    phone: Phone,
    gender: Gender,
    photo: Photo,
    dateBirth: DateBirth,
    isAdmin: IsAdmin,
    accessCode: AccessCode,
    position: Position,
    activeBranchId: ActiveBranchId,
    telCode: '',
  };

  return result;
};
